import axios from '@/jslib/axios'

export const createBanner = data => {
  return axios({
    method: 'post',
    url: '/admin/banner/create',
    data
  })
}
export const getBannerList = params => {
  return axios({
    method: 'get',
    url: '/admin/banner/list',
    params
  })
}
export const getBannerDetail = params => {
  return axios({
    method: 'get',
    url: '/admin/banner/detail',
    params
  })
}
export const sortBanner = data => {
  return axios({
    method: 'post',
    url: '/admin/banner/sort',
    data
  })
}